export const DNS_config_validator = {
  domain: {
    required: true,
    pattern: /(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]/,
    customErrorMessage:
      'Invalid domain name. If your domain is www.example.com, please use only example.com.'
  }
};
